import { render, staticRenderFns } from "./UserDetailsReport.vue?vue&type=template&id=01f9d398&"
import script from "./UserDetailsReport.vue?vue&type=script&lang=js&"
export * from "./UserDetailsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports